<script setup>
import ForbiddenWordBalloon from '../kijk_live_qmusic_nl_default/shared/ForbiddenWordBalloon.vue'
import CharacterJumpFromTheRight from '../kijk_live_qmusic_nl_default/text_animations/CharacterJumpFromTheRight.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

let alignment = '6tv:col-start-3 6tv:col-end-5 5tv:col-start-3 5tv:col-end-5'
switch (props.item?.properties?.align) {
  case 'left':
    alignment = 'col-start-1 col-end-3'
    break
  case 'right':
    alignment = '6tv:col-start-5 6tv:col-end-7 5tv:col-start-4 5tv:col-end-6'
    break
  default:
    break
}
const timelineHeaderWord = ref(null)
const timelineHeaderText = ref(null)
const timelineFooter = ref(null)
const timelineForbiddenWordBalloon = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'ForbiddenWordCounter' }).add(timelineHeaderWord, '>').add(timelineHeaderText, '<').add(timelineFooter, '<').add(timelineForbiddenWordBalloon, '<.03')
})
</script>

<template>
  <div class="grid 6tv:grid-cols-6 5tv:grid-cols-5 grid-cols-1 gap-0 w-full h-full z-10 q-corner:h-1/3">
    <div :class="alignment">
      <div class="flex flex-col h-full p-20 gap-4 items-center justify-center">
        <div class="font-cervo 6tv:w-full 5tv:w-full w-1/2 q-corner:w-2/3 text-center flex flex-col items-center justify-center">
          <div class="flex">
            <CharacterJumpFromTheRight
              class="text-white font-bold"
              textSizeClass="5tv:text-[12rem] 6tv:text-[16rem] text-[8rem] q-corner:text-[12rem]"
              textOutlineSizeClass="5tv:text-[16rem] 6tv:text-[20rem] text-[12rem] q-corner:text-[16rem]"
              :text="`'${item.properties.forbiddenWord}'`"
              @timeline="timelineHeaderWord = $event"
            />
            <CharacterJumpFromTheRight
              class="text-white"
              textSizeClass="5tv:text-[12rem] 6tv:text-[16rem] text-[8rem] q-corner:text-[12rem]"
              textOutlineSizeClass="5tv:text-[16rem] 6tv:text-[20rem] text-[12rem] q-corner:text-[16rem]"
              :text="` is al`"
              @timeline="timelineHeaderText = $event"
            />
          </div>
          <ForbiddenWordBalloon
            ref="forbiddenWordBalloon"
            class="font-bold text-q-cr-red-primary h-full 5tv:text-[42rem] text-[28rem]"
            :total="item?.enrichment.grandTotal ?? 0"
            @timeline="timelineForbiddenWordBalloon = $event"
          />
          <CharacterJumpFromTheRight
            class="text-white"
            textSizeClass="5tv:text-[12rem] 6tv:text-[16rem] text-[8rem] q-corner:text-[12rem]"
            textOutlineSizeClass="5tv:text-[16rem] 6tv:text-[20rem] text-[12rem] q-corner:text-[16rem]"
            :text="`keer gezegd`"
            @timeline="timelineFooter = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>
